import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BoardOfDirectorsService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiBoardOfDirectors/" + nameMethod, data, HEADERS);

  // getInformationFromBoardOfDirectors() Obtiene información de los indicadores de la junta directiva
  getInformationFromBoardOfDirectors = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getHarvestIndicators() Obtiene información de las cosechas
  getHarvestIndicators = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getProcessedData() Obtiene información de archivos R
  getProcessedData = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
